import { reactive } from 'vue';
import { useQuery } from 'vue-query';
import { UseQueryOptions } from 'react-query/types';
import QUERY_KEYS from '@/constants/queryKeys';
import useNetwork from '../useNetwork';
import { balancerFarmSubgraphService } from '@/services/balancer/subgraph/balancer-farm-subgraph.service';
import { BaseFlakeInfos } from '@/services/balancer/subgraph/types';

/**
 * TYPES
 */
type QueryResponse = BaseFlakeInfos[];

/**
 * Fetch all token lists, should only happen once.
 */
export default function useFlakePoolQuery(
  options: UseQueryOptions<QueryResponse> = {}
) {
  const { networkId } = useNetwork();

  const queryKey = reactive(QUERY_KEYS.FarmPools.BASEFLAKEINFOS(networkId));

  const queryFn = async () => {
    return await balancerFarmSubgraphService.baseFlakeInfos.get();
  };

  const queryOptions = reactive({
    enabled: true,
    ...options
  });

  return useQuery<QueryResponse>(queryKey, queryFn, queryOptions);
}
